import React from 'react';
import Banner from './Banner';

const Home = () => {
  return (
    <div className="home-main">
      <Banner />
    </div>
  );
}

export default Home;

